import React from "react";

function MapView({ lat, lng }) {
  return <div className='w-full h-64 rounded-lg'></div>;
}

export default MapView;
